import React, { useState } from 'react'
import { LanguageModal } from 'components/Modals/LanguageModal/LanguageModal'
import { LanguageMenuLink } from 'components/SidebarNavigation/MenuItem/LanguageMenuLink/LanguageMenuLink'

import styles from './LanguageSelector.module.scss'

export const LanguageSelector = () => {
  const [showLanguageModal, setShowLanguageModal] = useState(false)
  return (
    <div className={styles.LanguageModalWrapper}>
      <LanguageMenuLink onClick={() => setShowLanguageModal(true)} />
      <LanguageModal
        onClose={() => setShowLanguageModal(false)}
        isOpen={showLanguageModal}
      />
    </div>
  )
}
